export default __webpack_public_path__ + "static/media/ET2.dc16db4b.png";